import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    interestsCount: Number,
    forceFmt: Boolean,
    iveCompleted: Boolean,
    skipIveValidation: { type: Boolean, default: false }
  };
  static targets = ["checkbox", "fmtShiftField"];

  connect() {
    this.setupButtonObserver();
    this.update();
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupButtonObserver() {
    const submitButton = document.getElementById("candidate-form-submit");
    if (!submitButton) return;

    this.observer = new MutationObserver(() => {
      if (this.isSelfUpdating) return;
      this.enforceButtonState();
    });

    this.observer.observe(submitButton, {
      attributes: true,
      attributeFilter: ["disabled"],
    });
  }

  enforceButtonState() {
    const submitButton = document.getElementById("candidate-form-submit");
    if (!submitButton) return;

    this.isSelfUpdating = true;

    let hasChecked = false;
    let onlyInternship = false;

    if (this.forceFmtValue) {
      hasChecked = true;
      onlyInternship = false;
    } else {
      const checkedValues = this.checkboxTargets
        .filter((cb) => cb.checked)
        .map((cb) => cb.value);

      hasChecked = checkedValues.length > 0;
      onlyInternship = checkedValues.length === 1 && checkedValues[0] === 'internship';
    }

    const iveRequired = !onlyInternship && !this.skipIveValidationValue;
    const iveMissing = iveRequired && !this.iveCompletedValue;

    const errorMessage = document.getElementById("candidate-form-ive-error");
    if (errorMessage) {
      if (iveMissing && hasChecked) {
        errorMessage.classList.remove("d-none");
      } else {
        errorMessage.classList.add("d-none");
      }
    }

    const noProgramsError = document.getElementById("candidate-form-no-programs-error");
    if (noProgramsError) {
      if (!hasChecked) {
        noProgramsError.classList.remove("d-none");
      } else {
        noProgramsError.classList.add("d-none");
      }
    }

    if (!hasChecked || iveMissing) {
      submitButton.disabled = true;
    } else {
      const hasBirthdateError = document.getElementById("birthdate-submit-error") !== null;
      if (!hasBirthdateError) {
        submitButton.disabled = false;
      }
    }

    setTimeout(() => {
      this.isSelfUpdating = false;
    }, 0);
  }

  update() {
    const allPrograms = this.checkboxTargets.find(
      (cb) => cb.value === "all_programs"
    );

    if (allPrograms?.checked) {
      this.checkboxTargets.forEach((cb) => (cb.checked = true));
    }

    const othersUnchecked = this.checkboxTargets
      .filter((cb) => cb.value !== "all_programs")
      .some((cb) => !cb.checked);

    if (othersUnchecked && allPrograms) {
      allPrograms.checked = false;
    }

    if (!this.forceFmtValue) {
      const values = this.checkboxTargets
        .filter((cb) => cb.checked)
        .map((cb) => cb.value);
      const selectedWithoutAll = values.filter((v) => v !== "all_programs");
      const showFmt = selectedWithoutAll.includes("fmt");
      const shiftInput = this.fmtShiftFieldTarget.querySelector(
        "[name*='espro_fmt_shift_preference']"
      );

      this.fmtShiftFieldTarget.classList.toggle("d-none", !showFmt);

      if (shiftInput) {
        shiftInput.disabled = !showFmt;
      }

      this.enforceButtonState();
    }
  }
}
